export const loadScript = (url: URL | string, id: string, callback?: () => void , timeout = 1) => {
    let old: HTMLElement | null 
    old = document.getElementById( id )
    if( old)  old.remove();
    const el: HTMLScriptElement = document.createElement("script") 
    el.type = "text/javascript"
    el.src = url.toString()
    el.async = true
    el.id = id
    if( callback) {
        el.onload = callback
    } 
    setTimeout(() => {
        document.getElementsByTagName("body")[0].appendChild(el)
    }, timeout || 1)
}
export const removeScript = (id: string) => {
    var element = document.getElementById( id )
    if( !!element ){
        element.remove()
    }
}